import * as React from 'react';
import { useSelector } from 'react-redux';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, Menu, MenuItem } from '@mui/material';
import appConfig from '../../../config';
import { halcyonInstance, hanwahaInstance, gaTelesisInstance, jetStreamInstance } from '../../../shared_elements';


const TECHNICAL_SPECS_FEATURE_BY_ASSET_TYPE = {
    1: 'aircraft',
    2: 'engine',
    3: 'apu',
    4: 'landing_gears',
    5: 'propeller',
    6: 'engine',
};


const ASSET_TYPE_OPTIONS = [
    { label: 'Aircraft (MSN)', asset_type: 1 },
    { label: 'Engine (ESN)', asset_type: 2 },
    { label: 'Propeller', asset_type: 5 },
    { label: 'Landing Gear', asset_type: 4 },
    { label: 'APU', asset_type: 3 },
    { label: 'Module', asset_type: 6 },
];

const AddAssetBtn = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { permission } = useSelector((state) => state.leases);
    const checkPermission = ( feature, operation) =>
        Boolean(permission?.permissions?.console_application?.technical_specs?.[feature]?.includes(operation));
    const assetTypeOptions = ((halcyonInstance || hanwahaInstance)
        ? ASSET_TYPE_OPTIONS.filter((option) => option.asset_type === 2)
        : ASSET_TYPE_OPTIONS.filter((option) => {
            if (gaTelesisInstance && [5, 6].includes(option.asset_type)) return false;
            if (jetStreamInstance && option.asset_type === 6) return false;
            return true;
        })
    ).filter((option) => checkPermission(TECHNICAL_SPECS_FEATURE_BY_ASSET_TYPE[option.asset_type], 'C'));
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const onSelectAssetType = (asset_type) => {
        handleClose();
        window.open(`${appConfig.domain.subDomian}assets-listing?apps=lms&asset_type=${asset_type}`, '_self');
    };
    if (!assetTypeOptions.length) return null;
    return (
        <>
            <Button size='small' variant='contained' className='btn-primary' onClick={handleClick}  endIcon={<ArrowDropDownIcon fontSize='small' />}>
                Add Asset
            </Button>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {assetTypeOptions.map((option) => (
                    <MenuItem key={option.asset_type} onClick={() => onSelectAssetType(option.asset_type)}>{option.label}</MenuItem>
                ))}
            </Menu>
        </>
    )
}
export default AddAssetBtn;
